module.exports = __webpack_public_path__ + "static/media/tanque-verde_old.5c9d29ec.svg";